import { c as _c } from "react/compiler-runtime";
// hooks/useRestoreFileFromLocalStorage.ts

import type { IFile } from '@petsmart-ui/sparky';
import type { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
export function useRestoreFileFromLocalStorage(fieldName, formik, setLocalFiles) {
  const $ = _c(9);
  const {
    touched,
    errors,
    setTouched,
    setErrors,
    setFieldValue
  } = formik;
  const restoredRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== errors || $[1] !== fieldName || $[2] !== setErrors || $[3] !== setFieldValue || $[4] !== setLocalFiles || $[5] !== setTouched || $[6] !== touched) {
    t0 = () => {
      if (restoredRef.current) {
        return;
      }
      const raw = localStorage.getItem(fieldName as string);
      if (!raw) {
        return;
      }
      let meta;
      try {
        meta = JSON.parse(raw);
      } catch {
        return;
      }
      if (!meta.name || !meta.type || !meta.size) {
        return;
      }
      const fileObject = {
        name: meta.name,
        type: meta.type,
        size: meta.size,
        lastModified: Date.now()
      };
      const wrapper = {
        id: nanoid(),
        fileObject
      };
      setLocalFiles([wrapper]);
      setFieldValue(fieldName as string, fileObject, true);
      setTouched({
        ...touched,
        [fieldName]: true
      } as FormikTouched<TValues>);
      if (errors[fieldName]) {
        const newErrors = {
          ...errors
        } as FormikErrors<TValues>;
        delete newErrors[fieldName];
        setErrors(newErrors);
      }
      restoredRef.current = true;
    };
    t1 = [fieldName, setFieldValue, setTouched, setErrors, touched, errors, setLocalFiles];
    $[0] = errors;
    $[1] = fieldName;
    $[2] = setErrors;
    $[3] = setFieldValue;
    $[4] = setLocalFiles;
    $[5] = setTouched;
    $[6] = touched;
    $[7] = t0;
    $[8] = t1;
  } else {
    t0 = $[7];
    t1 = $[8];
  }
  useEffect(t0, t1);
}